import script from "./Nav.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nav.vue?vue&type=script&lang=ts&setup=true"

import "./Nav.vue?vue&type=style&index=0&id=4935d6b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4935d6b2"]])

export default __exports__